import React, { useContext } from 'react';

import { graphql, useStaticQuery } from 'gatsby';
import { useTranslation } from 'react-i18next';
import { ALL_LANGS } from '../../constants';
import { LandingPageContext } from '../../contexts/LandingPageContext';
import { getUrlFromVersatileLink, localize } from '../../utils/sanity';
import ButtonLink from './ButtonLink';

export interface ContactUsButtonProps {
  secondaryButton?: boolean;
  onClick?: React.MouseEventHandler<HTMLElement>;
  className?: string;
}

interface QueryData {
  sanityWebsite: {
    contactsPage: {
      slug: {
        current: string;
      };
    };
  };
}

const ContactUsButton = ({
  secondaryButton,
  onClick,
  className,
}: ContactUsButtonProps): React.ReactElement => {
  const queryData = useStaticQuery<QueryData>(graphql`
    {
      sanityWebsite {
        contactsPage {
          slug {
            current
          }
        }
      }
    }
  `);

  const { i18n, t } = useTranslation();

  const langs = [i18n.language, ...ALL_LANGS.filter(lang => lang !== i18n.language)];
  const localizedData: QueryData = localize(queryData, langs);

  const {
    sanityWebsite: { contactsPage },
  } = localizedData;

  const isLandingPage = useContext(LandingPageContext);

  return (
    <ButtonLink
      onClick={onClick}
      className={className}
      secondary={secondaryButton}
      to={getUrlFromVersatileLink(
        isLandingPage
          ? {
              linkType: 'internalLink',
              internalLink: {
                anchorLink: 'contact',
              },
            }
          : {
              linkType: 'internalLink',
              internalLink: {
                pageReference: {
                  __typename: 'SanityPage',
                  slug: {
                    current: contactsPage.slug.current,
                  },
                },
              },
            },
      )}
    >
      {t('menuContactButton.title', 'Contacte-nos')}
    </ButtonLink>
  );
};

export default ContactUsButton;
